module.exports = __webpack_public_path__ + "img/暂无内容.6a06c440.svg";